// Modul zur Beantragung von Rollstuhlplatz-Pauschalen
"use strict";

import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "./controller";
import template from "./template.jade";
import FoerderantragModels from "dias/foerderantrag/models";
import VertragModels from "dias/vertrag/models";

import builder from "dias/standard_foerdermodule/utils/builder";


const rückfoerderungsverzicht = angular.module("dias.rueckforderungsverzicht", [
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
  VertragModels.name,
]);

rückfoerderungsverzicht.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("rueckforderungsverzicht", "modul-rueckforderungsverzicht");
})

  .directive("modulRueckforderungsverzicht", builder.directive(template, controller));

export default rückfoerderungsverzicht;
